/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// $(".tabsDesk__header li").on("click", function () {
// 	console.log($(this).attr("data-tab"));
// });

let tabs = document.querySelectorAll(".tabsDesk__header li button");
tabs.forEach((element) => {
	element.addEventListener("click", function () {
		let tabs = document.querySelectorAll(".tabsDesk__body > li");
		tabs.forEach((element) => {
			element.style.display = "none";
		});

		let tabsButton = document.querySelectorAll(
			".tabsDesk__header li button"
		);
		tabsButton.forEach((element) => {
			element.classList.remove("active");
		});

		let tab = document.querySelector("#" + this.dataset.tab);
		tab.style.display = "block";
		this.classList.add("active");
	});
});

let brandsLi = document.querySelector('li[data-itemtitle="brands"]');
let brandDropdown = document.querySelector(".brandDropdown");
brandsLi.addEventListener("mouseover", () => {
	brandDropdown.style.display = "block";

	new Glide(".glide", {
		perView: 5,
		dragThreshold: false,
	}).mount();
});

brandDropdown.addEventListener("mouseover", () => {
	brandDropdown.style.display = "block";
});

brandDropdown.addEventListener("mouseleave", () => {
	brandDropdown.style.display = "none";
});

brandsLi.addEventListener("mouseleave", () => {
	brandDropdown.style.display = "none";
});

let brandsButtonsMob = document.querySelectorAll(
	".brandDropdownMobileLetters button"
);

let brandsLinksMob = document.querySelectorAll(".brandDropdownMobileLinks");

brandsButtonsMob.forEach((element) => {
	element.addEventListener("click", function () {
		brandsButtonsMob.forEach((element) => {
			element.classList.remove("active");
		});
		this.classList.add("active");

		brandsLinksMob.forEach((element) => {
			element.classList.remove("active");
		});

		document
			.querySelector("#" + this.dataset.mobbrand)
			.classList.add("active");
	});
});

// Variant iamges

// Add variant name to images without alt so we can match
$(".variantData li").each(function () {
	let datasrc = $(this).attr("data-src");
	let dataname = $(this).attr("data-name");

	$(".Product__SlideshowNavScroller a img").each(function () {
		let src = $(this).attr("src");

		if (src.includes(datasrc)) {
			$(this).attr("alt", dataname);
		}
	});
});

$("#variantSwatches li").each(function () {
	let variantName = $(this).attr("data-color");

	let index = $(this).index();

	if (
		$('.Product__SlideshowNavImage img[alt*="' + variantName + '-variant"]')
			.length
	) {
		var variantImg = $(
			'.Product__SlideshowNavImage img[alt="' + variantName + '-variant"]'
		).attr("src");
	} else {
		var variantImg = $(
			'.Product__SlideshowNavImage img[alt="' + variantName + '"]'
		).attr("src");
	}

	if (variantImg != null) {
		$(this).append(
			'<img title="' +
				variantName +
				'" width="40" src="' +
				variantImg +
				'">'
		);
	} else {
		$(this).append(
			'<img width="40" src="//cdn.shopify.com/s/files/1/0587/3257/6962/products/guru-awaiting-image_e10c1592-0a44-4afb-aac4-bda75b03cce2_160x.jpg?v=1633117987" class="swatchNoImage" title="' +
				variantName +
				'">'
		);
	}
});

if ($("#variantSwatches").length) {
	if ($('.Product__SlideshowNavImage img[alt*="-variant"]').length) {
		// $('.Product__SlideshowNavImage img[alt*="-variant"]')
		// 	.closest("a")
		// 	.remove();
	} else {
		// $(".Product__SlideshowNavImage").remove();
	}
}
// $('.Product__SlideshowNavImage:not(".is-selected")').closest("a").hide();
// $('.Product__SlideshowNavImage:not(".is-selected") img[alt="'++'"]').closest("a").hide();

let variantName = $(".Product__SlideshowNavScroller a.is-selected img").attr(
	"alt"
);
let altVariantName = $(".Product__SlideshowNavScroller a.is-selected img").closest(".Product__SlideshowNavImage").next().find("img").attr("alt")

console.log(variantName);
$(".Product__SlideshowNavScroller a").hide();
$(".Product__SlideshowNavScroller a img[alt='" + variantName + "']")
	.closest("a")
	.css("display", "inline-block");
$(".Product__SlideshowNavScroller a img[alt='" + variantName + "-variant']")
	.closest("a")
	.css("display", "inline-block");


// jquery that accounts for first display images having different alt text
$(".Product__SlideshowNavScroller a img[alt='" + altVariantName + "']")
	.closest("a")
	.css("display", "inline-block");
$(".Product__SlideshowNavScroller a img[alt='" + altVariantName + "-variant']")
	.closest("a")
	.css("display", "inline-block");


$(document).on("click", "#variantSwatches li", function () {
	let variantName = $(this).find("img").attr("title");

	setTimeout(function () {
		let variantButton = $(
			".Popover__ValueList button[data-value='" + variantName + "']"
		);
		variantButton[0].click();

		$(".Product__SlideshowNavScroller a").hide();
		$(".Product__SlideshowNavScroller a img[alt='" + variantName + "']")
			.closest("a")
			.css("display", "inline-block");
		$(
			".Product__SlideshowNavScroller a img[alt='" +
				variantName +
				"-variant']"
		)
			.closest("a")
			.css("display", "inline-block");
	}, 100);

	$(window).trigger("resize");
});

var isVariantChanged = false;

document.addEventListener("variant:changed", function (event) {
  	isVariantChanged = true;
	var variant = event.detail.variant; // Gives you access to the whole variant details

	$('.Product__SlideshowNavImage img[alt*="-variant"]').closest("a").hide();

	$(".Product__SlideshowNavScroller a").hide();
	let variantName = $(
		".Product__SlideshowNavScroller a.is-selected img"
	).attr("alt");
	// console.log(variantName);
	$(".Product__SlideshowNavScroller a img[alt='" + variantName + "']")
		.closest("a")
		.css("display", "inline-block");
	$(".Product__SlideshowNavScroller a img[alt='" + variantName + "-variant']")
		.closest("a")
		.css("display", "inline-block");
  	// PRODUCT SAMPLES APP

    $(".product-samples-button-wrap").removeClass('disabled');
});

// PRODUCT SAMPLES APP
document.body.addEventListener('afterRenderButton.productSamples', function () {
  if (productHasOnlyDefaultVariant) {
    return false;
  }
  $(".product-samples-button-wrap").addClass('disabled');
  $(".product-samples-button-wrap").on('click', function (e) {
    if (!isVariantChanged) {
      alert('Please choose colour from drop down list first!');
    }
  });
});

    // get the read more text button
    let readMoreBtn = document.querySelector('.prod_tabs_readMore');
	if (readMoreBtn != null) {
    // get the rte div
    let rte = document.querySelector('.Product__tabsDesk .ProductMeta__Description .Rte');
  
    // add click event to toggle active class on the rte div
    readMoreBtn.addEventListener('click', function() {
      rte.classList.toggle('active');
	  readMoreBtn.querySelector('span').innerHTML = readMoreBtn.querySelector('span').innerHTML === 'Continue Reading...' ? 'Read Less...' : 'Continue Reading...';
    });
}